<template>
  <div class="content fix-width">
    <div class="content-header">
      <h3>{{ t.allWorks.allSongs.name }}</h3>
    </div>
    <!-- form text -->
    <div class="form-info" v-html="t.allWorks.allSongs.info"></div>

    <!-- FORM  -->
    <div class="all-songs-form" v-if="select_options">
      <div class="form-content">
        <div class="flex-content">
          <!-- search-input -->
          <input
            type="text"
            class="search-input"
            v-model="form.queryTitle"
            :placeholder="t.searchTitle"
            v-on:keyup.enter="startSearch"
          />
          <input
            type="text"
            class="search-input"
            v-model="form.queryLyrics"
            :placeholder="t.searchlyricis"
            v-on:keyup.enter="startSearch"
          />
        </div>
        <!-- options area -->
        <div class="select-input-area">
          <!-- ESER -->
          <!-- <div class="select-content">
            <label for="eser">{{ t.select.work }}</label>
            <v-select 
                :closeOnSelect="false" 
                maxHeight="200px" 
                label="value" 
                :options="select_options.work" 
                multiple 
                v-model="form.work"></v-select>
          </div>-->
          <!-- ALBUM -->
          <div class="select-content">
            <label for="Eser">{{ t.select.album }}</label>
            <v-select
              :closeOnSelect="false"
              maxHeight="200px"
              label="value"
              :options="filter"
              multiple
              v-model="form.album"
              @search="onSearch"
              :filterable="false"
            >
              <span v-if="album_input >= 1 && !pending" slot="no-options">{{
                t.select_nomatching
              }}</span>
              <span v-if="album_input == undefined && !pending" slot="no-options">{{
                t.select_length
              }}</span>
              <span v-if="pending" slot="no-options">
                <i class="diginity dg-loading diginity-is-spinning"></i>
              </span>
            </v-select>
          </div>
          <!--  COMPOSER -->
          <div class="select-content">
            <label for="Eser">{{ t.select.composer }}</label>
            <v-select
              :closeOnSelect="false"
              maxHeight="200px"
              label="value"
              :options="select_options.composer"
              multiple
              v-model="form.composer"
            >
              <span slot="no-options">{{ t.select_nomatching }}</span>
            </v-select>
          </div>
          <!--  LYRICIST -->
          <div class="select-content">
            <label for="Eser">{{ t.select.lyricist }}</label>
            <v-select
              :closeOnSelect="false"
              maxHeight="200px"
              label="value"
              :options="select_options.lyricist"
              multiple
              :searchable="true"
              v-model="form.lyricist"
            >
              <span slot="no-options">{{ t.select_nomatching }}</span>
            </v-select>
          </div>
          <!-- EDITOR -->
          <div class="select-content">
            <label for="Eser">{{ t.select.editor }}</label>
            <v-select
              :closeOnSelect="false"
              maxHeight="200px"
              label="value"
              :options="select_options.editor"
              multiple
              v-model="form.editor"
            >
              <span slot="no-options">{{ t.select_nomatching }}</span>
            </v-select>
          </div>
          <!-- PERFORMER -->
          <div class="select-content">
            <label for="Eser">{{ t.select.performer }}</label>
            <v-select
              :closeOnSelect="false"
              maxHeight="200px"
              label="value"
              :options="select_options.performer"
              multiple
              v-model="form.performer"
            >
              <span slot="no-options">{{ t.select_nomatching }}</span>
            </v-select>
          </div>
          <!-- YEAR -->
          <div class="select-content">
            <label for="Eser">{{ t.select.year }}</label>
            <v-select
              :closeOnSelect="false"
              maxHeight="200px"
              label="label"
              :options="years"
              multiple
              v-model="form.year"
            >
              <span slot="no-options">{{ t.select_nomatching }}</span>
            </v-select>
          </div>
        </div>
        <div class="form-end-controls">
          <!-- search button -->
          <button :disabled="ajax" class="form-button" @click="startSearch">
            {{ t.find }}
          </button>
          <button class="form-button" @click="clearForm">{{ t.cleared }}</button>
        </div>
      </div>
    </div>
    <template v-else>
      <div class="spinner spinner_load small">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
        <span>{{ t.ready }}...</span>
      </div>
    </template>
    <!--  <| RESULT TABLE |> -->
    <span id="result"></span>

    <div
      class="search-result-content"
      v-if="search_song_list !== undefined && search_song_list.length > 0"
    >
      <div class="search-works-content">
        <div class="search-info">
          <small v-html="t.select.result(filterSearch.length)"></small>
        </div>
        <label class="search-input-filter">
          <input type="text" :placeholder="t.resultInSearch" v-model="filterInput" />
        </label>
      </div>
      <!--  DOWNLOAD -->
      <template v-if="exportCheck">
        <download-excel
          class="download diginity dg-xls"
          :title="xlsTitle(false)"
          :data="filterSearch"
          :fields="json_fields"
          worksheet="My Worksheet"
          :name="xlsTitle(true)"
        >
          <span></span>
        </download-excel>
      </template>
      <div class="result-table">
        <table>
          <thead>
            <tr>
              <th>{{ t.select.work }}</th>
              <th>{{ t.select.composer }}</th>
              <th>{{ t.select.lyricist }}</th>
              <th>{{ t.select.editor }}</th>
              <th>{{ t.select.performer }}</th>
              <th>{{ t.select.album }}</th>
              <th>{{ t.select.year }}</th>
              <th v-if="exportCheck">ISRC</th>
              <th>{{ t.select.listen }}</th>
              <th>{{ t.select.note }}</th>
              <th>{{ t.select.lyrics }}</th>
            </tr>
          </thead>
          <paginate
            v-if="filterSearch.length"
            ref="work_list"
            name="workList"
            :list="filterSearch"
            :per="10"
            :refreshCurrentPage="true"
            tag="tbody"
            :async="true"
          >
            <!-- result listing -->
            <tr v-for="(song, i) in paginated('workList')" :key="i">
              <td>{{ song.Key }}</td>
              <td>{{ replaced(song.Contributors, "Composer:") }}</td>
              <td>{{ replaced(song.Contributors, "Lyricist:") }}</td>
              <td>{{ replaced(song.Contributors, "Editor:") }}</td>
              <td>{{ replaced(song.Contributors, "Performer:") }}</td>
              <td>{{ song.AlbumName }}</td>
              <td>{{ song.AlbumYear }}</td>
              <td v-if="exportCheck">{{ song.ISRC }}</td>
              <td>
                <!-- track -->
                <span
                  class="diginity"
                  @click="change(song.FileLink, i)"
                  :class="{
                    'track-demo': true,
                    'dg-play-border': i !== current,
                    'dg-stop-border': i == current,
                    pulse: i == current,
                  }"
                ></span>
              </td>
              <td>
                <!-- note -->
                <a
                  target="_BLANK"
                  :href="
                    'https://docs.google.com/gview?url=' + file(song.NotesFileLink, true)
                  "
                  v-if="song.NotesFileLink"
                  class="lyric-btn diginity dg-note"
                  @click="stop()"
                ></a>
              </td>
              <td>
                <!-- lyrics -->
                <span
                  v-if="song.Lyrics"
                  class="lyric-btn diginity dg-lyrics"
                  @click="selectLyricObj(song.Key, song.Lyrics), stop()"
                ></span>
              </td>
            </tr>
          </paginate>
        </table>
        <paginate-links
          v-if="search_song_list.length"
          for="workList"
          :limit="3"
          :show-step-links="true"
          :async="true"
          :hide-single-page="true"
          @change="stop()"
        ></paginate-links>
      </div>
      <!-- Demo player -->
    </div>
    <p v-if="search_song_list == undefined">{{ t.resultNotFound }}</p>
    <!-- First loading serching -->
    <template v-if="ajax">
      <div class="spinner spinner_load small">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </template>
    <div class="form-info" v-html="t.allWorks.allSongs.end"></div>
    <!-- MODAL for lyrics -->
    <transition name="fade">
      <template v-if="selectLyrics">
        <div class="term-of-use">
          <div class="contex" v-click-outside="close">
            <div class="close">
              <h3>{{ selectLyrics.title }}</h3>
              <span @click="close" class="diginity dg-close"></span>
            </div>
            <div class="tou-content">
              <div class="static-page" v-html="selectLyrics.lyrics"></div>
            </div>
          </div>
        </div>
      </template>
    </transition>
    <transition name="fade">
      <template v-if="selectNote">
        <div class="term-of-use pdf">
          <!-- top line -->
          <div class="contex" style="width: 800px; height: 100%">
            <iframe
              src="http%3A%2F%2Fadmin.sezenaksu.com.tr%2Ffiles%2Fpub%2F%3Fid%3DOQSztVyV2Diam764RHbWtdhHfxVmJvpyBw%252B%252Fe1y7A34%253D"
              frameborder="0"
            ></iframe>
          </div>
        </div>
      </template>
    </transition>
    <Aplayer
      ref="demoSongP"
      style="display: none"
      controls
      mini
      :volume="1"
      :music="{
        src: musicSource,
      }"
      @ended="onMusicEnded"
      @pause="toggle"
    />
  </div>
</template>

<script>
// import vSelect from 'vue-multiselect'
import { mapGetters } from "vuex";
import Aplayer from "vue-aplayer";
import axios from "axios";
export default {
  data() {
    return {
      paginate: ["workList"],
      pending: false,
      musicSource: "not",
      current: undefined,
      queryResult: false,
      ajax: false,
      album_input: undefined,
      auto_load: false,
      selectLyrics: undefined,
      selectNote: undefined,
      filter: [],
      filterInput: "",
      form: {
        composer: [],
        lyricist: [],
        editor: [],
        performer: [],
        album: [],
        year: [],
        queryTitle: "",
        queryLyrics: "",
      },
    };
  },
  computed: {
    ...mapGetters(["lng", "t", "select_options", "search_song_list", "file"]),
    // construct select item for YEAR
    years() {
      const currentYear = new Date().getFullYear();
      const date = [];
      for (let i = 1975; i < currentYear + 1; i++) {
        date.push({
          value: i,
          label: i.toString(),
        });
      }
      return date.reverse();
    },
    // filtered result listing with v-model filterInput
    filterSearch() {
      var rx = new RegExp(this.filterInput.toLowerCase(), "gi");
      // if original not found search
      return this.search_song_list !== undefined
        ? this.search_song_list.filter((m) => {
            return (
              m.Key.toLocaleLowerCase().match(rx) ||
              m.Contributors.toLocaleLowerCase().match(rx) ||
              m.AlbumName.toLocaleLowerCase().match(rx) ||
              m.AlbumYear.toString().match(rx)
            );
          })
        : undefined;
    },
    json_fields() {
      var json = {};
      json[this.t.select.work] = "Key";
      json[this.t.select.composer] = {
        field: "Contributors",
        callback: (value) => {
          return this.replaced(value, "Composer:");
        },
      };

      json[this.t.select.lyricist] = {
        field: "Contributors",
        callback: (value) => {
          return this.replaced(value, "Lyricist:");
        },
      };
      json[this.t.select.editor] = {
        field: "Contributors",
        callback: (value) => {
          return this.replaced(value, "Editor:");
        },
      };
      json[this.t.select.performer] = {
        field: "Contributors",
        callback: (value) => {
          return this.replaced(value, "Performer:");
        },
      };

      json[this.t.select.album] = "AlbumName";
      json[this.t.select.year] = "AlbumYear";
      json["ISRC"] = "ISRC";
      return json;
    },
    // query params
    exportCheck() {
      var params = this.$route.query;
      if (params.hasOwnProperty("export")) {
        return true;
      }
      return false;
    },
  },
  watch: {
    // song files fixed URL
    search_song_list(newValue, oldValue) {
      this.$scrollTo("#result", this.$store.state.scrollSpeed);
    },
    // watch filtered list change after paused audio player
    filterSearch(n, o) {
      if (n !== o) {
        this.stop();
      }
    },
  },
  methods: {
    xlsTitle(type) {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var hh = today.getHours();
      var mn = today.getMinutes();
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      if (hh < 10) {
        hh = "0" + hh;
      }
      if (mn < 10) {
        mn = "0" + mn;
      }
      return type == true
        ? `SezenAKSU_${dd}.${mm}.${yyyy}_${hh}${mn}.xls`
        : `Sezen AKSU ( ${dd}/${mm}/${yyyy} ${hh}:${mn} )`;
    },
    // paused audio player function
    stop() {
      this.musicSource = "not";
      this.$refs.demoSongP.pause();
      this.current = undefined;
    },
    // replace Contributors inside
    replaced(item, type) {
      const ex = item ? item.split(",") : [];
      const end = [];
      ex.find((s) => {
        if (s.match(type)) {
          end.push(s.replace(type, ""));
        }
      });
      return end.join(", ");
    },
    // autocomplete (ALBUM select) async
    async onSearch(search, loading) {
      this.album_input = search.length;
      if (search.length >= 3) {
        var typ;
        clearInterval(typ);
        const _ = this;
        this.pending = true;
        typ = setTimeout(async () => {
          const autocomplete = await _.$store.dispatch("autocomplete_songs", search);

          _.filter = autocomplete;
          _.pending = autocomplete !== undefined ? false : true;
        }, 1000);
      } else {
        this.album_input = undefined;
        this.filter = [];
      }
    },
    // clear form
    clearForm() {
      this.form = {
        work: [],
        composer: [],
        lyricist: [],
        editor: [],
        performer: [],
        album: [],
        year: [],
        queryTitle: "",
        queryLyrics: "",
        query: "",
      };
    },
    // search ajax preload show/hide and post ajax (ASYNC)
    async startSearch() {
      $(".search-input").blur();
      this.filterInput = "";
      if (
        this.form.composer.length ||
        this.form.lyricist.length ||
        this.form.editor.length ||
        this.form.performer.length ||
        this.form.album.length ||
        this.form.year.length ||
        this.form.queryTitle.length ||
        this.form.queryLyrics.length ||
        this.form.query.length
      ) {
        // post search loading
        this.ajax = true;
        const ajaxRequest = await this.$store.dispatch("search_request", this.form);

        // return false
        this.ajax = ajaxRequest;
        // refresh current page
        // this.$refs.work_list.goToPage(1);
        // warn form params empty
      } else {
        alert(this.t.select_area_length);
      }
      // restart current page index
      this.$refs.work_list.goToPage(1);
    },
    // shown lyric data
    selectLyricObj(Key, Content, type) {
      if (type) {
        this.selectNote = Content;
      } else {
        this.selectLyrics = {
          title: Key,
          lyrics: Content,
        };
      }
    },
    // close modal (need outside directive function)
    close() {
      this.selectLyrics = undefined;
      this.selectNote = undefined;
      this.pdfLoad = true;
      this.currentPage = 1;
      this.pageCount = 0;
    },
    // is paused demoPlayer
    toggle(e) {
      this.current = undefined;
    },
    // demoplayer ending music refresh class and icon
    onMusicEnded() {
      this.current = undefined;
    },
    // demoplayer click song play or pause
    change(src, pts) {
      // this.musicSource = this.file(src);
      const demoSongP = this.$refs.demoSongP;
      // if playing
      if (demoSongP.isPlaying) {
        // stop the same song selected
        if (this.file(src) == demoSongP.currentMusic.src) {
          this.musicSource = "not";
          demoSongP.pause();
          this.current = undefined;
          // clicked on different song
        } else {
          this.musicSource = this.file(src);
          this.current = pts;
          demoSongP.thenPlay();
        }
        // song does not play
      } else {
        this.musicSource = this.file(src);
        this.current = pts;
        demoSongP.thenPlay();
      }
    },
  },
  // if component/router out after form cleared
  beforeDestroy() {
    this.clearForm();
    this.$store.dispatch("search_request", "empty");
  },
  // before created
  components: { Aplayer },
};
</script>

<style lang="scss" scoped>
@import "../../styles/colors";
.download {
  vertical-align: bottom;
  font-size: 25px;
  margin: 10px;
  cursor: pointer;
  color: #81279f;
  &:hover {
    color: #ad26da;
  }
}
.search-works-content {
  display: flex;
  align-items: center;
  padding: 10px 0;
  justify-content: space-between;

  .search-info {
    font-size: 13px;
  }
  .search-input-filter {
    display: flex;
    align-items: center;
    input {
      font-size: 10px;
      width: 100%;
      min-width: 250px;
    }
  }
}
.dg-loading {
  color: $main;
  font-size: 15px;
  font-weight: bold;
  animation-duration: 1s !important;
}
.fix-width {
  width: calc(100% - 260px);
  @media screen and (max-width: 760px) {
    width: 100%;
  }
}
.spinner span {
  color: $main;
}
.form-end-controls {
  display: flex;
  justify-content: flex-end;
  padding: 40px 0;
  button.form-button {
    background: $main;
    border: 1px solid $mainDark;
    color: #fff;
    padding: 5px 10px;
    width: 150px;
    font-size: 15px;
    &[disabled],
    &[disabled]:hover {
      background: #888;
      border: 1px solid #555;
    }
    cursor: pointer;
    @media screen and (max-width: 480px) {
      width: 50%;
      &:first-child {
        width: calc(50% - 5px);
      }
    }
    &:first-child {
      margin-right: 5px;
    }
    &:hover {
      background: $mainDark;
    }
  }
}
.form-info {
  font-size: 13px;
  color: #8c8c8c;
  line-height: 22px;
  padding: 30px 0;
}
.all-songs-form {
  .form-content {
    .flex-content {
      display: flex;
      margin: 0 -5px;
      @media screen and (max-width: 760px) {
        margin: 0;
        flex-direction: column;
      }
      .search-input {
        font-size: 18px;
        padding: 8px;
        color: #444;
        margin: 0 5px;
        &::placeholder {
          /* Chrome, Firefox, Opera, Safari 10.1+ */
          color: #888;
          opacity: 0.6;
        }
        @media screen and (max-width: 760px) {
          margin: 5px 0;
        }
      }
    }

    .select-input-area {
      display: flex;
      flex-wrap: wrap;
      margin-top: 30px; // justify-content: space-between;
      .select-content {
        padding: 5px;
        width: 33.33333%;
        @media screen and (max-width: 760px) {
          width: 50%;
        }
        label {
          width: 100%;
          color: #444;
          display: block;
          padding-left: 3px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 13px;
        }
      }
    }
  }
}
button {
  outline: none;
  &:focus {
    outline: none;
  }
}
.search-result-content {
  .result-table {
    overflow-x: auto;
    overflow-y: hidden;
    margin-bottom: 20px;
    width: 100%;
    table {
      cursor: default;
      border-collapse: collapse;
      width: 100%;
      thead {
        th {
          vertical-align: middle;
          padding: 3px 3px;
          line-height: 16px;
          font-size: 10px;
          background: $main;
          color: #fff;
          border: 1px solid $main;
          border-right-color: #fff;
          border-left-color: #fff;
        }
      }
      tbody {
        td {
          border: 1px solid #ccc;
          text-align: center;
          vertical-align: middle;
          font-size: 10px;
          padding: 5px 3px;
          background: #fff;
          color: #8c8c8c;
          span,
          a {
            cursor: pointer;
            font-size: 20px;
            color: $mainLight;
            &:hover {
              color: $main;
            }
          }
        }
      }
    }
  }
}
.dg-stop-border {
  animation-name: color;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}
@keyframes color {
  0% {
    color: $main;
  }
  50% {
    color: dodgerblue;
  }
  100% {
    color: $main;
  }
}
.term-of-use {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  .contex {
    background: #fff;
    height: 100%;
    overflow: hidden;
    width: 100%;
    padding: 5px;
    @media screen and (min-width: 500px) {
      width: 500px;
    }
    .close {
      padding: 10px;
      font-weight: bold;
      color: #555;
      display: flex;
      justify-content: space-between;
      font-size: 25px;
      h3 {
        padding: 0;
        margin: 0;
        margin-top: 5px;
        font-size: 20px;
        color: $main;
        margin-left: 30px;
      }
      span {
        margin-right: 20px;
        cursor: pointer;
        &:hover {
          color: red;
        }
      }
    }
    .tou-content {
      text-align: left;
      padding: 10px;
      height: calc(100% - 54px);
      font-size: 14px;
      color: #444;
      overflow-y: auto;
    }
  }
}
</style>
